// npm packages
import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { motion } from "framer-motion";
import { toast, ToastContainer } from "react-toastify";

// custom pages
import "react-toastify/dist/ReactToastify.css";
import "./ImportQualityData.css";
import getAllVraShiftAPIS from "apis/panel/vraShifts/vraShifts.js";
import upload from "../../../../assets/images/rpHomePage/upload.gif";
import Context from "context/context";
import leftarrow from "assets/images/arrow-right.png";
import commonAPI from "apis/panel/Common/common";
import Tables from "components/table/table";

// masterial ui
import { Box } from "@mui/material";

const ImportQualityData = () => {
  const navigate = useNavigate();
  const { dispatch } = useContext(Context);
  const { fileUploadQualityDataAPI } = getAllVraShiftAPIS();
  const { getBackgroundProcessLogsAPI } = commonAPI();
  const [uploadProgress, setUploadProgress] = useState(0);
  const [logsData, setLogsData] = useState([]);
  const [logsOffset, setLogsOffset] = useState(1);
  const [logsCount, setLogsCount] = useState(0);
  const [logsResponse, setLogsResponse] = useState(false);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: {
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        ".xlsx",
      ],
      "application/vnd.ms-excel": [".xls"],
    },
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length > 0) {
        handleFileUpload(acceptedFiles[0]);
      } else {
        toast.error("Only Excel files are allowed.");
      }
    },
  });

  const handleNavigation = () => {
    navigate("/panel/rpHomePage");
  };

  const handleFileUpload = async (file) => {
    const maxSize = 1024 * 1024 * 100; // 30MB
    if (file.size > maxSize) {
      // Show error message if file size exceeds the limit
      toast.error("File size exceeds the limit (100MB)", {
        toastId: "file-upload-maximum",
      });
      return;
    }

    try {
      dispatch({ type: "SET_LOADING", payload: true });
      const response = await fileUploadQualityDataAPI(file);
      if (response?.status === "Ok") {
        toast.success(response?.message || "File uploaded successfully!");
      } else {
        toast.error(
          response?.message || "Network issue detected. Please try again later."
        );
      }
      if (logsOffset < 2) {
        handleGetBackgroundLogs();
      } else {
        setLogsOffset(1);
      }
      dispatch({ type: "SET_LOADING", payload: false });
      return;
    } catch (err) {
      dispatch({ type: "SET_LOADING", payload: false });
      // Handle and log error
      console.error("Error uploading file:", err);
      toast.error("Error uploading file.");
    }
  };

  const handleGetBackgroundLogs = async () => {
    try {
      let values;
      values = {
        offset: (logsOffset - 1) * 20,
        limit: 20,
        processName: "UPLOAD_QUALITY_DATA",
      };

      const res = await getBackgroundProcessLogsAPI(values);
      console.log({res})
      setLogsResponse(true);
      setLogsData(res?.data?.data || []);
      setLogsCount(res?.data?.count);
    } catch (err) {}
  };

  useEffect(() => {
    handleGetBackgroundLogs();
  }, [logsOffset]);

  return (
    <div style={{ backgroundColor: "white", borderRadius: "10px" }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          onClick={handleNavigation}
          style={{ cursor: "pointer", paddingRight: 8 }}
        >
          <img src={leftarrow} alt="Back" />
        </div>
        <Box sx={{ pt: 2, pb: 2, pl: 1 }} className="VraShiftsTitle">
          Import Quality Data
        </Box>
      </div>

      <div
        className="containerforupload"
        style={{ display: "flex", justifyContent: "center", gap: "40px" }}
      >
        <div style={{ textAlign: "center" }}>
          <motion.div
            className="upload-area"
            {...getRootProps()}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            <input {...getInputProps()} />
            <div className="instructions">
              {isDragActive ? (
                <img
                  style={{ width: "40%" }}
                  src={upload}
                  alt="Upload indicator"
                />
              ) : (
                <>
                  <img
                    style={{ width: "40%" }}
                    src={upload}
                    alt="Upload indicator"
                  />
                  <p style={{ color: "lightgrey" }}>
                    Drag and drop your Excel files here
                  </p>
                </>
              )}
            </div>
          </motion.div>
        </div>

        {/* Display progress bar */}
        {uploadProgress > 0 && (
          <div className="progress-container">
            <div
              className="progress-bar"
              style={{ width: `${uploadProgress}%` }}
            >
              {uploadProgress}%
            </div>
          </div>
        )}
        <ToastContainer />
      </div>

      {logsResponse && (
        <div>
        <Tables
          title={
            <Box sx={{ pt: 2, pb: 2 }} className="VraShiftsTitle">
              Logs
            </Box>
          }
          searchBar={false}
          heading={[
            "S.No",
            "File Name",
            "Start Time",
            "End Time",
            "Duration",
            "Success Count",
            "Failure Count",
            "Progress",
            "Status",
            "Initiated By",
          ]}
          data={logsData?.map((d, index) => [
            (logsOffset - 1) * 20 + index + 1,
            ,
            d.file_name,
            <span style={{whiteSpace:"nowrap"}}>{d.start_time}</span>,
            <span style={{whiteSpace:"nowrap"}}>{d.end_time}</span>,
            d.duration,
            d.success_count,
            d.failure_count,
            d.progress ? `${d.progress}%` : "",
            d.status,
            d.initiated_by,
          ])}
          offset={logsOffset}
          setOffset={setLogsOffset}
          limit={20}
          count={logsCount}
          placeholder="Search Employee Code, SRF Name, Full..."
        />
        </div>
      )}
    </div>
  );
};

export default ImportQualityData;
